import TomSelect from 'tom-select/dist/esm/tom-select.js';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));

    initRefinementsMenu();
    initSearchMobile();
    initOrderResultsSelect();
    viewItemPaginationInit();
});

$(document).on('search:applied', function () {
    let refinementsToggler = $('.js-refinements-toggler');
    let refinementsClose = $('.js-close-refinements');
    let refinementsElement = $('.js-refinements');

    initSearchMobile();
    initRefinementsMenu();
    initOrderResultsSelect();
    refinementsClosing(refinementsToggler,refinementsClose,refinementsElement);

    if (refinementsElement.hasClass('show')) {
        if (!refinementsToggler.hasClass('active')){
            refinementsToggler.addClass('active');
        }
    }

    syncRefinementsInert(refinementsElement);
});

function syncRefinementsInert(element) {
    let el = element && element[0];
    if (!el) {
        return;
    }
    if (element.hasClass('show')) {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
    } else {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
    }
}

function initRefinementsMenu() {
    let refinementsElement = $('.js-refinements');
    let refinementsToggler = $('.js-refinements-toggler');

    let refinementsClose = $('.js-close-refinements');

    syncRefinementsInert(refinementsElement);

    refinementsToggler.click(function () {
        refinementsToggler.toggleClass('active');
        refinementsElement.toggleClass('show');

        if(refinementsElement.hasClass('show')) {
            if (BreakpointHelper.isUpTo('xl')) {
                let productGridHeight = $('.search-results-container .grid-container')[0].offsetHeight;
                refinementsElement.css('max-height', productGridHeight + 'px');
            } else {
                refinementsElement.css('max-height',  '100%');
            }

            if (BreakpointHelper.isDownTo('md')) {
                $('body').css('overflow', 'hidden');
            }
        } else {
            refinementsElement.css('max-height', '0');
        }

        syncRefinementsInert(refinementsElement);
    })

    refinementsClosing(refinementsToggler,refinementsClose,refinementsElement);
}

function refinementsClosing(toggler, closeBtn, element) {
    closeBtn.click(function() {
        toggler.removeClass('active');
        element.removeClass('show');
        if (BreakpointHelper.isDownTo('md')) {
            $('body').css('overflow', 'auto');
        }
        syncRefinementsInert(element);
    });
}

function viewItemPaginationInit() {
    let viewItemSelect = $('#view-item-pagination');

    viewItemSelect.on('change', function(){
        let permalink = $('input:hidden.permalink')[0].value;
        window.location = permalink.split('sz=')[0] + 'sz=' + this.value;
    });
}

function initOrderResultsSelect() {
    if ($('.js-order-results').length) {
        const orderSelect = new TomSelect('.js-order-results', {
            create: false,
            sortField: {
                field: "text",
                direction: "asc"
            },
            controlInput: null,
            render: {
                option: function(data) {
                    return '<div class="radio">'+
                        '<input id="radio-' + data.text +'" name="radio" type="radio" tabindex="-1"' + (this.items[0] === data.text ? 'checked' : '') + '>'+
                        '<label for="radio-' + data.text +'" class="radio-label">'+ data.text + '</label>'+
                        '</div>';
                }
            },
            onDropdownOpen: function() {
                if (BreakpointHelper.isDownTo('md')) {
                    $('body').css('overflow', 'hidden');
                }
            },
            onDropdownClose: function() {
                if (BreakpointHelper.isDownTo('md')) {
                    $('body').css('overflow', 'auto');
                }
            }
        });

        $('.js-order-results.tom-select .ts-control').append('<span class="icon icon-arrow-down ml-3"></span><span class="icon icon-arrow-up ml-3"></span>');
        $('.js-order-results.tom-select  .ts-dropdown').append(
            '<div class="close-select-bar d-lg-none">' +
            '    <span class="icon icon-plus js-close-select close-select"></span>' +
            '    <span class="order-top-banner">Ordina</span>' +
            '</div>' +
            '<label class="order-top-label d-lg-none">Ordina per</label>' +
            '<div class="order-select-sticky-bar d-lg-none">' +
            '   <button class="apply-button js-close-select">Applica</button>' +
            '</div>'
        );

        $('.js-close-select').on('click', function(){
            orderSelect.close();
        });
    }

}

function initSearchMobile() {
    let searchBarContainer = $('.js-search-bar-container');
    let searchOpenBtnMobile = $('.js-open-search-mobile');
    let searchCloseBtnMobile = $('.js-close-search-mobile');
    let searchCancelBtnMobile = $('.js-search-cancel-button');

    searchOpenBtnMobile.on('click', function(){
        searchBarContainer.addClass('active');
        if (BreakpointHelper.isDownTo('md')) {
            $('body').css('overflow', 'hidden');
        }
    });

    searchCloseBtnMobile.on('click', function (){
        searchBarContainer.removeClass('active');
        if (BreakpointHelper.isDownTo('md')) {
            $('body').css('overflow', 'auto');
        }
    });

    searchCancelBtnMobile.on('click', function (){
        searchBarContainer.removeClass('active');
        if (BreakpointHelper.isDownTo('md')) {
            $('body').css('overflow', 'auto');
        }
    });
}
